export default __webpack_public_path__ + "static/media/hero-image-sm.2b91753c.png";